module.exports = __webpack_public_path__ + "static/img/vip.f19b2144.png";